import { Dashboard } from '@/features/dashboard'

const DashboardPage = () => {
  return <Dashboard />
}

export default DashboardPage
